import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { ColorTypes, MenuEvent } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { BaseSidebar, Browser, BrowserEvent, BrowserState } from "@reporting/rp-app-host";
import { style } from "./sidebar.style";
import { DWHBrowserAdapter } from "../adapters";
import { AccountingRights } from "@reporting/rp-types/core";
import { DWHApplication } from "..";

@customElement('rp-dwh-sidebar')
export class Sidebar extends BaseSidebar<DWHApplication> {

	static styles = [...BaseSidebar.styles, style];

	@query('rp-browser')
	browser: Browser;

	private _browserAdapter: DWHBrowserAdapter;
    get browserAdapter() { 
        if (!this._browserAdapter) {
            this._browserAdapter = new DWHBrowserAdapter();
        }
        return this._browserAdapter;
    }

	firstUpdated() {
		this.browser.addEventListener('browser.state', this._onChangeState);
		this.browser.state = this.state?.dwhBrowser as BrowserState;
	}

	getState() {
		return {
			name: 'sidebar',
			dwhBrowser: this.browser?.getState(),
		}
	}

	_onChangeState = () => {
		this.dispatchStateEvent();
	}
	
	refresh = () => {
		this.browser.refresh();
	}

	toggleCollapse = () => {
		this.browser.tree.toggleTreeCollapse();
	};

	_onSelect = (e: BrowserEvent) => {
		rp.host.open(e.node.key, { title: e.node.value });
	}

	render = () => html`
		<div class="controls">
			<og-button
				icon="search"
				color="transparent"
				text="${msg('Search')}"
				style="flex: 1"
				@click="${() => rp.host.openCommands('DWH')}">
			</og-button>

			<og-button
				icon="arrows-rotate"
				title="${msg('Refresh')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.refresh()}">
			</og-button>

			<og-button
				icon="square-plus"
				title="${msg('Collapse/Expand tree')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.toggleCollapse()}">
			</og-button>
		
		</div>

		<div class="body">
			<rp-browser id="browser" .adapter="${this.browserAdapter}" @browser.select="${this._onSelect}"></rp-browser>
		</div>
	`;

}
